var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "personal-center" },
    [
      _c(
        "el-form",
        {
          staticClass: "form",
          attrs: { model: _vm.personData, "label-width": "130px" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("卡包设置")]),
          _vm.personData && _vm.personData.card_setting
            ? _c("div", { staticClass: "line" }, [
                _c(
                  "div",
                  { staticClass: "item" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "我的卡券：",
                          prop: "card_setting.my_card_name_alias",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "inputStyle",
                          attrs: { disabled: "", maxlength: "4" },
                          model: {
                            value:
                              _vm.personData.card_setting.my_card_name_alias,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.personData.card_setting,
                                "my_card_name_alias",
                                $$v
                              )
                            },
                            expression:
                              "personData.card_setting.my_card_name_alias",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "卡包名称：",
                          prop: "card_setting.my_card_alias",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "inputStyle",
                          attrs: { disabled: "", maxlength: "4" },
                          model: {
                            value: _vm.personData.card_setting.my_card_alias,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.personData.card_setting,
                                "my_card_alias",
                                $$v
                              )
                            },
                            expression: "personData.card_setting.my_card_alias",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "卡规则显示开关：",
                          prop: "card_setting.card_rule_display_switch",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: "" },
                            model: {
                              value:
                                _vm.personData.card_setting
                                  .card_rule_display_switch,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.personData.card_setting,
                                  "card_rule_display_switch",
                                  $$v
                                )
                              },
                              expression:
                                "personData.card_setting.card_rule_display_switch",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("显示"),
                            ]),
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v("隐藏"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "item" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "券包名称：",
                          prop: "card_setting.my_coupon_alias",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "inputStyle",
                          attrs: { disabled: "", maxlength: "4" },
                          model: {
                            value: _vm.personData.card_setting.my_coupon_alias,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.personData.card_setting,
                                "my_coupon_alias",
                                $$v
                              )
                            },
                            expression:
                              "personData.card_setting.my_coupon_alias",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "绑卡名称：",
                          prop: "card_setting.my_bind_card_alias",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "inputStyle",
                          attrs: { disabled: "", maxlength: "4" },
                          model: {
                            value:
                              _vm.personData.card_setting.my_bind_card_alias,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.personData.card_setting,
                                "my_bind_card_alias",
                                $$v
                              )
                            },
                            expression:
                              "personData.card_setting.my_bind_card_alias",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "付款码显示开关：",
                          prop: "card_setting.card_rule_display_switch",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: "" },
                            model: {
                              value:
                                _vm.personData.card_setting
                                  .show_static_qrcode_rule,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.personData.card_setting,
                                  "show_static_qrcode_rule",
                                  $$v
                                )
                              },
                              expression:
                                "personData.card_setting.show_static_qrcode_rule",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v(
                                "渠道规则（" +
                                  _vm._s(
                                    _vm.personData.card_setting
                                      .show_static_qrcode_rule_channel == 0
                                      ? "隐藏"
                                      : "显示"
                                  ) +
                                  "）"
                              ),
                            ]),
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("显示"),
                            ]),
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v("隐藏"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c("el-divider"),
          _c("div", { staticClass: "title" }, [_vm._v('商城 "我的" 页面')]),
          _vm.personData && _vm.personData.shop_display_setting
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "消息：",
                            prop: "shop_display_setting.show_message",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.shop_display_setting
                                    .show_message,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.shop_display_setting,
                                    "show_message",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.shop_display_setting.show_message",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "我的收藏：",
                            prop: "shop_display_setting.show_my_collection",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.shop_display_setting
                                    .show_my_collection,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.shop_display_setting,
                                    "show_my_collection",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.shop_display_setting.show_my_collection",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "证件资质：",
                            prop: "shop_display_setting.show_certificate_qualification",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.shop_display_setting
                                    .show_certificate_qualification,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.shop_display_setting,
                                    "show_certificate_qualification",
                                    $$v
                                  )
                                },
                                expression:
                                  "\n\t\t\t\t\t\t\t\tpersonData.shop_display_setting.show_certificate_qualification\n\t\t\t\t\t\t\t",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "购物车：",
                            prop: "shop_display_setting.show_shopping_cart",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.shop_display_setting
                                    .show_shopping_cart,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.shop_display_setting,
                                    "show_shopping_cart",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.shop_display_setting.show_shopping_cart",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "电话客服：",
                            prop: "shop_display_setting.show_telephone_service",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.shop_display_setting
                                    .show_telephone_service,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.shop_display_setting,
                                    "show_telephone_service",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.shop_display_setting.show_telephone_service",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "地址管理：",
                            prop: "shop_display_setting.show_address_management",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.shop_display_setting
                                    .show_address_management,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.shop_display_setting,
                                    "show_address_management",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.shop_display_setting.show_address_management",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "在线客服：",
                            prop: "shop_display_setting.show_online_service",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.shop_display_setting
                                    .show_online_service,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.shop_display_setting,
                                    "show_online_service",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.shop_display_setting.show_online_service",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("el-divider"),
          _c("div", { staticClass: "title" }, [_vm._v("个人信息展示设置")]),
          _vm.personData && _vm.personData.persona_display_setting
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "更换头像：",
                            prop: "persona_display_setting.show_change_headimg",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_change_headimg,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_change_headimg",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_change_headimg",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "员工工号：",
                            prop: "persona_display_setting.show_workno",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_workno,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_workno",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_workno",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "手机号：",
                            prop: "persona_display_setting.show_mobile",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_mobile,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_mobile",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_mobile",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "会员性别：",
                            prop: "persona_display_setting.show_gender",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_gender,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_gender",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_gender",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "公司简称：",
                            prop: "persona_display_setting.customer_short",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "inputStyle",
                            attrs: { disabled: "" },
                            model: {
                              value:
                                _vm.personData.persona_display_setting
                                  .customer_short,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.personData.persona_display_setting,
                                  "customer_short",
                                  $$v
                                )
                              },
                              expression:
                                "personData.persona_display_setting.customer_short",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "我的企业：",
                            prop: "persona_display_setting.show_change_company",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_change_company,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_change_company",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_change_company",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "部门：",
                            prop: "persona_display_setting.show_department",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_department,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_department",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_department",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "公司名称：",
                            prop: "persona_display_setting.show_company_name",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_company_name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_company_name",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_company_name",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "更换手机号：",
                            prop: "persona_display_setting.show_change_mobile",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_change_mobile,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_change_mobile",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_change_mobile",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "姓名：",
                            prop: "persona_display_setting.show_realname",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_realname,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_realname",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_realname",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "职级：",
                            prop: "persona_display_setting.show_position",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_position,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_position",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_position",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "会员生日：",
                            prop: "persona_display_setting.show_birthday",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_birthday,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_birthday",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_birthday",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "入职时间：",
                            prop: "persona_display_setting.show_entry_time",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.persona_display_setting
                                    .show_entry_time,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.persona_display_setting,
                                    "show_entry_time",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.persona_display_setting.show_entry_time",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("el-divider"),
          _c("div", { staticClass: "title" }, [_vm._v("绑卡信息页设置")]),
          _vm.personData && _vm.personData.bind_card_view_config
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "页面名称：",
                            prop: "bind_card_view_config.index_title",
                            rules: [
                              {
                                required: true,
                                message: "请输入",
                                trigger: "change",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "inputStyle",
                            attrs: {
                              disabled: "",
                              "show-word-limit": "",
                              maxlength: "8",
                            },
                            model: {
                              value:
                                _vm.personData.bind_card_view_config
                                  .index_title,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.personData.bind_card_view_config,
                                  "index_title",
                                  $$v
                                )
                              },
                              expression:
                                "\n\t\t\t\t\t\t\t\tpersonData.bind_card_view_config.index_title\n\t\t\t\t\t\t\t",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "卡字段名称：",
                            prop: "bind_card_view_config.card_num_title",
                            rules: [
                              {
                                required: true,
                                message: "请输入",
                                trigger: "change",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "inputStyle",
                            attrs: {
                              disabled: "",
                              "show-word-limit": "",
                              maxlength: "6",
                            },
                            model: {
                              value:
                                _vm.personData.bind_card_view_config
                                  .card_num_title,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.personData.bind_card_view_config,
                                  "card_num_title",
                                  $$v
                                )
                              },
                              expression:
                                "\n\t\t\t\t\t\t\t\tpersonData.bind_card_view_config.card_num_title\n\t\t\t\t\t\t\t",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "卡字段提示：",
                            prop: "bind_card_view_config.card_num_prompt",
                            rules: [
                              {
                                required: true,
                                message: "请输入",
                                trigger: "change",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "inputStyle",
                            attrs: {
                              disabled: "",
                              "show-word-limit": "",
                              maxlength: "20",
                            },
                            model: {
                              value:
                                _vm.personData.bind_card_view_config
                                  .card_num_prompt,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.personData.bind_card_view_config,
                                  "card_num_prompt",
                                  $$v
                                )
                              },
                              expression:
                                "\n\t\t\t\t\t\t\t\tpersonData.bind_card_view_config.card_num_prompt\n\t\t\t\t\t\t\t",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "提交按钮：",
                            prop: "bind_card_view_config.add_button_title",
                            rules: [
                              {
                                required: true,
                                message: "请输入",
                                trigger: "change",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "inputStyle",
                            attrs: {
                              disabled: "",
                              "show-word-limit": "",
                              maxlength: "8",
                            },
                            model: {
                              value:
                                _vm.personData.bind_card_view_config
                                  .add_button_title,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.personData.bind_card_view_config,
                                  "add_button_title",
                                  $$v
                                )
                              },
                              expression:
                                "\n\t\t\t\t\t\t\t\tpersonData.bind_card_view_config.add_button_title\n\t\t\t\t\t\t\t",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "扫码提交：",
                            prop: "bind_card_view_config.scan_button_show",
                            rules: [
                              {
                                required: true,
                                message: "请选择",
                                trigger: "change",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.personData.bind_card_view_config
                                    .scan_button_show,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.personData.bind_card_view_config,
                                    "scan_button_show",
                                    $$v
                                  )
                                },
                                expression:
                                  "personData.bind_card_view_config.scan_button_show",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("隐藏"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.personData.bind_card_view_config.scan_button_show ===
                      "1"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "",
                                prop: "bind_card_view_config.scan_button_title",
                                rules: [
                                  {
                                    required: true,
                                    message: "请输入",
                                    trigger: "change",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "inputStyle",
                                attrs: {
                                  disabled: "",
                                  "show-word-limit": "",
                                  maxlength: "8",
                                },
                                model: {
                                  value:
                                    _vm.personData.bind_card_view_config
                                      .scan_button_title,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.personData.bind_card_view_config,
                                      "scan_button_title",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n\t\t\t\t\t\t\t\tpersonData.bind_card_view_config.scan_button_title\n\t\t\t\t\t\t\t",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "底部提示：",
                            prop: "bind_card_view_config.bind_card_prompt",
                            rules: [
                              {
                                required: true,
                                message: "请输入",
                                trigger: "change",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "inputStyle",
                            attrs: {
                              type: "textarea",
                              disabled: "",
                              "show-word-limit": "",
                              maxlength: "200",
                              autosize: { minRows: 3, maxRows: 100 },
                            },
                            model: {
                              value:
                                _vm.personData.bind_card_view_config
                                  .bind_card_prompt,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.personData.bind_card_view_config,
                                  "bind_card_prompt",
                                  $$v
                                )
                              },
                              expression:
                                "\n\t\t\t\t\t\t\t\tpersonData.bind_card_view_config.bind_card_prompt\n\t\t\t\t\t\t\t",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                      },
                      attrs: { span: 16 },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { width: "300px", height: "500px" } },
                        [
                          _c("img", {
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: {
                              src: require("../../../../icons/svg/bangka.jpg"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c("el-col", { attrs: { span: 16 } }, [
                    _c("img", { attrs: { src: "", alt: "" } }),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }